export function validateProfileForm(form = {}) {
  const errors = {};

  if (!form.name?.trim()) {
    errors.name = 'Profile name is required';
  }

  if (!form.organisation) {
    errors.organisation = 'Organisation is required';
  }

  return errors;
}

export function hasValidationErrors(errors = {}) {
  return Object.keys(errors).length > 0;
}
